import {computeSupportsMerge} from 'notebook/tables/store/logic/TableMergingLogic';
import {createTableStoreSelector} from 'notebook/tables/store/selectors/util/SelectorCreators';
import {TableEditableStore} from 'notebook/tables/store/TableStore';

/**
 * Model containing properties related to merging cells within a table.
 */
export interface TableMergingModel {
  /**
   * Whether merging cells is enabled for this table as a feature.
   * True when the `disableMergingCells` prop is not set.
   */
  isEnabled: boolean;

  /**
   * Whether the table supports merging/unmerging cells (i.e. the merge and
   * unmerge mutations are available). Currently equivalent to `isEnabled`, since
   * the merge mutations are gated solely by `disableMergingCells`.
   */
  supportsMerge: boolean;
}

/**
 * Creates a memoized selector that computes the TableMergingModel from the store.
 */
export function createTableMergingSelector(): (store: TableEditableStore) => TableMergingModel {
  return createTableStoreSelector(
    {
      disableMergingCells: (store) => store.stableProps.disableMergingCells ?? false,
    },
    ({disableMergingCells}) => ({
      isEnabled: !disableMergingCells,
      supportsMerge: computeSupportsMerge(disableMergingCells),
    })
  );
}
